import Image from 'next/image';

import styles from './index.module.css';

export const HomeDescriptionHTML = () => {
  const imageUrls = [
    'https://d11o05pl2tdcd2.cloudfront.net/blog-images/1745957758041-352217506-image.webp',
    'https://d11o05pl2tdcd2.cloudfront.net/blog-images/1745957907885-334814359-image.webp',
    'https://d11o05pl2tdcd2.cloudfront.net/blog-images/1745957922445-272063976-image.webp',
    'https://d11o05pl2tdcd2.cloudfront.net/blog-images/1745958044752-274364574-image.webp',
    'https://d11o05pl2tdcd2.cloudfront.net/blog-images/1745958088987-5011036-image.webp',
    'https://d11o05pl2tdcd2.cloudfront.net/blog-images/1745958109219-125554386-image.webp',
  ];

  const sections = [
    {
      number: 1,
      title: 'Check the RTP of Casino Games',
      isBold: true,
      image: imageUrls[0],
      content:
        'Look at the RTP (Return to Player) percentages for the games offered by the casino. Higher RTP values generally mean better chances of winning. RTPCheck provides accurate data on RTP, so you can see how the casino stacks up.',
    },
    {
      number: 2,
      title: 'Read Player Reviews',
      isBold: true,
      image: imageUrls[1],
      content:
        'Player feedback offers insights into the overall experience with the casino, including how often RTP matches the advertised rates and any issues players might have encountered. Reviews can help you gauge the reliability and fairness of the casino.',
    },
    {
      number: 3,
      title: 'Before Playing, Check the RTP of Casino Games',
      isHeading: true,
      image: imageUrls[2],
      content: [
        {
          text: 'Understand Your Odds:',
          bold: true,
          isNumbered: true,
          number: 1,
        },
        ' RTP (Return to Player) indicates the percentage of wagered money that a game will return to players over time. Higher RTP means better odds of winning.',
        {
          text: 'Avoid Low RTP Games:',
          bold: true,
          isNumbered: true,
          number: 2,
        },
        ' Games with low RTP can significantly reduce your chances of winning. By checking RTP, you avoid games that are less favorable to players.',
        {
          text: 'Make Informed Decisions:',
          bold: true,
          isNumbered: true,
          number: 3,
        },
        ' Knowing the RTP helps you choose games with better payout rates, allowing you to make strategic decisions about where to place your bets.',
        {
          text: 'Maximize Your Winnings:',
          bold: true,
          isNumbered: true,
          number: 4,
        },
        ' Playing games with higher RTP increases your potential for returns, giving you more value for your money and a better chance of winning.',
        {
          text: 'Protect Your Bankroll:',
          bold: true,
          isNumbered: true,
          number: 5,
        },
        ' Understanding RTP helps manage your bankroll more effectively by choosing games that offer better long-term returns and reducing the risk of significant losses.',
        { text: 'Verify Fairness:', bold: true, isNumbered: true, number: 6 },
        ' RTP data ensures that the casino is transparent and fair. If RTP is hidden or manipulated, it may indicate unfair practices, and checking RTP helps you avoid such casinos.',
        {
          text: 'Enhance Your Gaming Experience:',
          bold: true,
          isNumbered: true,
          number: 7,
        },
        " Playing games with favorable RTP can lead to a more enjoyable and rewarding gaming experience, as you're more likely to see returns on your bets.",
      ],
      footer:
        "By keeping an eye on the RTP of casino games, you ensure that you're playing in a fair and potentially profitable environment.",
    },
    {
      number: 4,
      title: 'Read Player Reviews and Check Ratings on Our Website',
      isHeading: true,
      content: [
        `Player reviews offer valuable insights by sharing firsthand accounts of experiences with different casinos, shedding light on aspects such as reliability, customer service, and overall gameplay quality. Reviews often highlight common issues like payment delays or poor customer support, enabling you to avoid casinos with potential problems. They also provide a glimpse into game fairness and RTP (Return to Player), allowing you to assess whether a casino's games are transparent and trustworthy. Additionally, our website's comprehensive ratings, based on factors like game selection and user experience, make it easier to compare various casinos and find the most reliable options.`,
        `Staying informed about a casino's reputation is crucial, and reviews and ratings reveal its standing within the player community. High ratings and positive feedback generally indicate a trustworthy platform, while recent reviews keep you up to date on any changes in policies or game offerings. By combining player reviews with expert ratings, you get a well-rounded view of a casino's strengths and weaknesses, empowering you to make informed choices. This information can help you avoid scams and unreliable casinos, ensuring that your gaming experience is both safe and enjoyable.`,
        `By reading player reviews and checking ratings on our website, you ensure that you are making well-informed decisions, ultimately leading to a safer and more enjoyable gaming experience.`,
      ],
    },
    {
      number: 5,
      title:
        'Check the Number of Complaints and the Speed of Problem Resolution',
      isHeading: true,
      image: imageUrls[3],
      content: [
        "Assessing customer support efficiency is crucial for understanding how well a casino addresses player issues. A high volume of complaints can signal problems with service quality, so checking how swiftly and effectively these complaints are resolved reveals the casino's dedication to supporting its players. Additionally, evaluating the casino's problem resolution practices can provide insight into their responsiveness and dispute-handling capabilities. A casino that quickly resolves issues is likely to offer superior support and a more positive experience overall.",
        `Understanding common complaints helps identify potential red flags, such as payment delays, unfair gaming practices, or unresponsive support teams. Casinos with a low number of complaints and quick resolution times generally prove to be more reliable, showing that they proactively address player concerns and maintain their reputation. Quick and fair treatment of complaints reflects the casino's commitment to valuing its players, which enhances the gaming experience.`,
        `If a casino consistently shows a pattern of unresolved issues or slow responses, it's best to steer clear. On the other hand, casinos that focus on resolving issues and improving their service indicate a commitment to player satisfaction. Considering these factors allows you to make an informed choice, selecting casinos that offer dependable support and a reliable gaming environment.`,
      ],
    },
    {
      number: 6,
      title: 'Why Choose RTPCheck.com?',
      isMainHeading: true,
      image: imageUrls[4],
      content: [
        'Unbiased reviews without moderation provide genuine feedback from real players, ensuring you receive authentic insights without censorship or filtering. This transparency allows you to see both the positive and negative sides of each casino, offering a balanced perspective on their strengths and weaknesses. Our commitment to publishing all reviews—regardless of their nature—fosters trust and transparency, helping you make well-informed choices.',
        'Our comprehensive blacklist is a vital tool for identifying casinos with consistent issues, such as unfair practices or poor customer service, so you can avoid problematic operators. This list protects your interests by pointing out casinos known for dishonest practices like lowering RTP, helping safeguard your gaming experience. We regularly update our blacklist based on player feedback and industry trends to keep you informed of the latest unreliable operators.',
        'We provide detailed RTP data to help you make informed decisions based on real, transparent RTP percentages. This accurate information enables you to compare RTP data across various casinos, assisting in selecting the ones that offer the best return to players. Our platform is a trusted resource for players, drawing on industry expertise and player feedback to offer reliable and accurate information. We adopt a player-centric approach, focusing on detailed insights into casino operations and player experiences.',
        `Regular updates and maintenance ensure that our reviews, RTP data, and blacklist stay current. We continuously monitor the casino landscape, identifying and reporting new issues or improvements to keep you up to date. Our user-friendly interface is designed for easy navigation, allowing you to quickly find RTP information, reviews, and casino ratings. With easily accessible data, whether you're searching for specific RTP percentages or detailed player experiences, our platform makes it simple to gather the information you need.`,
        `By choosing RTPCheck.com, you gain access to a wealth of unbiased, up-to-date information that empowers you to make informed decisions and avoid casinos that might not be in your best interest.`,
      ],
    },
    {
      number: 7,
      title: 'Online Casinos to Avoid',
      isMainHeading: true,
      image: imageUrls[5],
      content: [
        "When it comes to choosing where to play online, not all casinos are created equal. Some online casinos engage in practices that can significantly disadvantage players. To help you avoid these pitfalls, we've established a blacklist of casinos that fall short in critical areas.",
        { text: 'Reduced RTP:', bold: true },
        ` Some casinos are known for lowering the Return to Player (RTP) percentages on their games. This means that players face diminished chances of winning compared to the standard RTP offered by game providers. Such practices are deceptive and undermine the integrity of the gaming experience. Casinos that consistently show reduced RTPs are placed on our blacklist to protect players from these unfair practices.`,
        { text: 'Non-Payment of Winnings:', bold: true },
        " Another serious issue is casinos that do not pay out players' winnings. This could be due to various reasons, including fraudulent activity, unclear terms and conditions, or poor financial practices. Casinos that fail to honor their financial commitments are also added to our blacklist to ensure players do not waste their time and money on unreliable platforms.",
        { text: 'Check the Blacklist:', bold: true },
        " Before committing to any online casino, it's crucial to consult our blacklist. This list includes casinos that have been flagged for either reducing RTP or failing to pay out winnings. By checking the blacklist, you can avoid these problematic casinos and choose more trustworthy options for your gaming activities.",
        'By staying informed and cautious, you can ensure a safer and more enjoyable online gaming experience. Always review the blacklist and check RTP data before playing to protect yourself from potential issues.',
      ],
    },
  ];

  // Helper to render content with proper formatting
  const renderContent = (content: any) => {
    if (typeof content === 'string') {
      return <p>{content}</p>;
    }

    if (Array.isArray(content)) {
      return content.map((item, index) => {
        if (typeof item === 'string') {
          return (
            <p key={index} className={styles.paragraph}>
              {item}
            </p>
          );
        }

        if (typeof item === 'object') {
          if (item.isNumbered) {
            return (
              <div key={index} className={styles.numberedItem}>
                <span className={item.bold ? styles.boldText : ''}>
                  {item.number}. {item.text}
                </span>
                {item.description && <span>{item.description}</span>}
              </div>
            );
          }

          return (
            <span key={index} className={item.bold ? styles.boldText : ''}>
              {item.text}
            </span>
          );
        }

        return null;
      });
    }

    return null;
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>
          How to Choose the Online Casino Using RTPCheck?
        </h2>
        <p className={styles.subtitle}>
          When selecting an online casino for real money, consider these key
          factors with RTPCheck:
        </p>
      </div>

      <div className={styles.sectionsContainer}>
        {sections.map((section, index) => (
          <div key={index} className={styles.section}>
            <div className={styles.sectionHeader}>
              <div className={styles.numberCircle}>
                <span className={styles.numberText}>{section.number}</span>
              </div>
              {section.isMainHeading ? (
                <h2 className={styles.mainSectionTitle}>{section.title}</h2>
              ) : section.isHeading ? (
                <h3 className={styles.sectionHeading}>{section.title}</h3>
              ) : (
                <div
                  className={
                    section.isBold
                      ? styles.boldSectionTitle
                      : styles.sectionTitle
                  }
                >
                  {section.title}
                </div>
              )}
            </div>

            {section.image && (
              <Image
                className={styles.sectionImage}
                src={section.image}
                alt={section.title}
                width={820}
                height={461}
                sizes="(max-width: 820px) 100vw, 820px"
              />
            )}

            <div className={styles.sectionContent}>
              {renderContent(section.content)}

              {section.footer && (
                <p className={styles.sectionFooter}>{section.footer}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
